/** A segmented radiogroup that switches a list between views (Matrix/List, Tiles/List). */

import type { ComponentType } from 'react';

export interface ViewOption<K extends string> {
  key: K;
  label: string;
  Icon: ComponentType<{ 'aria-hidden'?: boolean | 'true' | 'false' }>;
}

export function ViewToggle<K extends string>({
  options,
  value,
  onChange,
  label,
}: {
  options: ViewOption<K>[];
  value: K;
  onChange: (key: K) => void;
  label: string;
}) {
  return (
    <div className="segmented view-toggle" role="radiogroup" aria-label={label}>
      {options.map(({ key, label: name, Icon }) => (
        <button key={key} type="button" role="radio" aria-checked={value === key} onClick={() => onChange(key)}>
          <Icon aria-hidden="true" />
          {name}
        </button>
      ))}
    </div>
  );
}
